/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ExtendAgentGamingAgentWatchlistMutationVariables = {
    agentId: string;
    comment: string;
};
export type ExtendAgentGamingAgentWatchlistMutationResponse = {
    readonly extendAgentGamingAgentWatchlist: {
        readonly success: boolean;
    } | null;
};
export type ExtendAgentGamingAgentWatchlistMutation = {
    readonly response: ExtendAgentGamingAgentWatchlistMutationResponse;
    readonly variables: ExtendAgentGamingAgentWatchlistMutationVariables;
};



/*
mutation ExtendAgentGamingAgentWatchlistMutation(
  $agentId: ID!
  $comment: String!
) {
  extendAgentGamingAgentWatchlist(agentId: $agentId, comment: $comment) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "comment"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "agentId",
        "variableName": "agentId"
      },
      {
        "kind": "Variable",
        "name": "comment",
        "variableName": "comment"
      }
    ],
    "concreteType": "ExtendAgentGamingAgentWatchlist",
    "kind": "LinkedField",
    "name": "extendAgentGamingAgentWatchlist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExtendAgentGamingAgentWatchlistMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExtendAgentGamingAgentWatchlistMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "01a591c0922ceb3b403c1578ea8d4578",
    "id": null,
    "metadata": {},
    "name": "ExtendAgentGamingAgentWatchlistMutation",
    "operationKind": "mutation",
    "text": "mutation ExtendAgentGamingAgentWatchlistMutation(\n  $agentId: ID!\n  $comment: String!\n) {\n  extendAgentGamingAgentWatchlist(agentId: $agentId, comment: $comment) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '79a4800702266f68869ad5ed925823b0';
export default node;
